import React from 'react'
import {
  Items,
  NavButton
} from './Styles'

// icons
import ListIcon from 'components/StaticIcons/Navigation/List'
import FriendsIcon from 'components/StaticIcons/Navigation/Friends'
import DebugIcon from 'components/StaticIcons/Navigation/Debug'

// components
import Counter from 'components/Counter'
import DebugModal from 'components/ModalSystem/Modals/Debug'

// state
import ModalState from 'components/ModalSystem/ModalState'

interface IItem {
  icon: React.ReactElement;
  location: string;
  show: boolean;
  badage: number;
}


export default function Navigation() {

  const Structure = [
    {
      icon: <ListIcon />,
      location: "/",
      badage: 0,
      show: true
    },
    {
      icon: <FriendsIcon />,
      location: "/friends",
      badage: 4,
      show: true
    },
    {
      icon: <b>3</b>,
      location: "/",
      badage: 4,
      show: false
    }
  ]

  return (
    <Items>

      {Structure.map(({ icon, show, badage, location }: IItem, index: number) => {

        if (!show)
          return <></>

        return (
          <NavButton to={location} key={index}>
            {icon}
            {badage > 0 && <Counter value={badage} />}
          </NavButton>
        )
      })}

      <NavButton title="debug panel" onClick={() => { ModalState.setComponent(<DebugModal />) }} to={window.location.pathname}>
        <DebugIcon />
      </NavButton>

    </Items>
  )
}